/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_EllipsisInputs */

const en_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project...`)
};

const fr_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet...`)
};

const de_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt...`)
};

const it_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto...`)
};

const ru_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект...`)
};

const es_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto...`)
};

const zh_cn2_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目...`)
};

const ja_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト...`)
};

const hi_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना...`)
};

const pt_pt2_project_ellipsis = /** @type {(inputs: Project_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto...`)
};

/**
* | output |
* | --- |
* | "Project..." |
*
* @param {Project_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_ellipsis = /** @type {((inputs?: Project_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_ellipsis(inputs)
	if (locale === "de") return de_project_ellipsis(inputs)
	if (locale === "it") return it_project_ellipsis(inputs)
	if (locale === "ru") return ru_project_ellipsis(inputs)
	if (locale === "es") return es_project_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_project_ellipsis(inputs)
	if (locale === "ja") return ja_project_ellipsis(inputs)
	if (locale === "hi") return hi_project_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_project_ellipsis(inputs)
	return en_project_ellipsis(inputs)
});